export interface TopicCategory {
    id: string;
    name: string;
    items: string[];
}

export const CONTESTACAO_TOPICS: TopicCategory[] = [
    {
        id: 'preliminares',
        name: 'Preliminares (Processo e Forma)',
        items: [
            'Inépcia da petição inicial',
            'Ilegitimidade ativa',
            'Ilegitimidade passiva',
            'Ausência de interesse processual',
            'Falta de pressupostos de constituição e desenvolvimento válido do processo',
            'Incapacidade da parte',
            'Incapacidade de representação ou defeito de representação',
            'Irregularidade de citação',
            'Incompetência absoluta',
            'Incompetência relativa',
            'Conexão',
            'Continência',
            'Litispendência',
            'Coisa julgada',
            'Convenção de arbitragem',
            'Carência de ação',
            'Falta de caução ou garantia legal exigida',
            'Indevida concessão da justiça gratuita',
            'Impugnação ao pedido de justiça gratuita',
            'Impugnação ao valor da causa',
            'Impugnação ao rito processual adotado',
            'Pedido de extinção sem resolução do mérito'
        ]
    },
    {
        id: 'prescricao_decadencia',
        name: 'Prescrição e Decadência',
        items: [
            'Prescrição',
            'Decadência',
            'Perempção'
        ]
    },
    {
        id: 'tutelas',
        name: 'Tutelas de Urgência e Evidência',
        items: [
            'Impugnação ao pedido de tutela provisória',
            'Impugnação à tutela de urgência',
            'Impugnação à tutela de evidência'
        ]
    },
    {
        id: 'provas',
        name: 'Provas',
        items: [
            'Impugnação ao pedido de inversão do ônus da prova',
            'Impugnação à produção de prova pericial',
            'Impugnação à prova documental',
            'Impugnação à prova testemunhal',
            'Impugnação à juntada intempestiva de documentos',
            'Impugnação a documentos estrangeiros'
        ]
    },
    {
        id: 'intervencao_terceiros',
        name: 'Intervenção de Terceiros',
        items: [
            'Impugnação à legitimidade de terceiros intervenientes',
            'Impugnação à assistência simples',
            'Impugnação à assistência litisconsorcial',
            'Impugnação ao chamamento ao processo',
            'Impugnação à denunciação da lide',
            'Impugnação ao litisconsórcio ativo',
            'Impugnação ao litisconsórcio passivo'
        ]
    },
    {
        id: 'pedidos_contraposto',
        name: 'Pedidos Específicos e Reconvenção',
        items: [
            'Impugnação à cumulação de pedidos',
            'Impugnação à reconvenção',
            'Impugnação ao pedido contraposto',
            'Impugnação ao pedido de exibição de documentos'
        ]
    },
    {
        id: 'valores_calculos',
        name: 'Valores e Cálculos',
        items: [
            'Impugnação à liquidez do pedido',
            'Impugnação à certeza do pedido',
            'Impugnação à exigibilidade do pedido',
            'Impugnação à base de cálculo do pedido',
            'Impugnação aos juros pleiteados',
            'Impugnação à correção monetária pleiteada',
            'Impugnação à multa pleiteada',
            'Impugnação à cláusula penal',
            'Impugnação ao pedido de condenação solidária'
        ]
    },
    {
        id: 'danos',
        name: 'Danos e Responsabilidade Civil',
        items: [
            'Impugnação à responsabilidade objetiva',
            'Impugnação ao nexo causal',
            'Impugnação ao dano material',
            'Impugnação ao dano moral',
            'Impugnação ao dano estético',
            'Impugnação ao lucro cessante',
            'Impugnação ao dano emergente'
        ]
    },
    {
        id: 'honorarios_custas',
        name: 'Honorários e Custas',
        items: [
            'Impugnação ao pedido de honorários',
            'Impugnação ao pedido de honorários sucumbenciais elevados',
            'Impugnação à sucumbência mínima'
        ]
    },
    {
        id: 'obrigacoes',
        name: 'Obrigações e Cumprimento',
        items: [
            'Impugnação ao pedido genérico',
            'Impugnação ao pedido ilíquido',
            'Impugnação ao pedido de condenação futura',
            'Impugnação ao pedido de obrigação de fazer',
            'Impugnação ao pedido de obrigação de não fazer',
            'Impugnação ao pedido de astreintes',
            'Impugnação ao valor das astreintes',
            'Impugnação à cumulação indevida de sanções',
            'Impugnação à execução provisória',
            'Impugnação à forma de cumprimento da sentença'
        ]
    },
    {
        id: 'argumentacao_juridica',
        name: 'Argumentação Jurídica',
        items: [
            'Impugnação à base fática do pedido',
            'Impugnação à base jurídica do pedido',
            'Impugnação à aplicação de precedente obrigatório',
            'Impugnação à aplicação de súmula',
            'Distinção de precedente (distinguishing)',
            'Superação de precedente (overruling)',
            'Arguição de litigância de má-fé',
            'Impugnação à alegação de litigância de má-fé',
            'Arguição de abuso do direito de ação',
            'Impugnação à alegação de abuso do direito de defesa'
        ]
    },
    {
        id: 'requerimentos',
        name: 'Requerimentos Finais',
        items: [
            'Pedido de saneamento do processo',
            'Pedido de julgamento antecipado do mérito'
        ]
    }
];
